import { Switch } from "@xola/ui-kit";
import React from "react";
import { useSeller } from "../../hooks/useAccount";
import { queryClient } from "@/api/queryClient";
import { canBookPastDates } from "@/models/Seller";
import { allowPastDates } from "@/stores/globalStore";

interface PastAvailabilitySwitchProps {
    isChecked: boolean;
    onChange: () => void;
}

export const PastAvailabilitySwitch = ({ isChecked = false, onChange }: PastAvailabilitySwitchProps) => {
    const seller = useSeller();
    if (!allowPastDates()) {
        return null;
    }

    if (!canBookPastDates(seller)) {
        return null;
    }

    const handleChange = (e: any) => {
        if (!e) {
            queryClient.invalidateQueries(["timeslots", "collection", "infinite"]);
        }

        onChange();
    };

    return (
        <div data-testid="past-availability-switch" className="p-5">
            <Switch.Group>
                <Switch isChecked={isChecked} size="medium" onChange={handleChange} />
                <Switch.Label direction="right">Show past availability</Switch.Label>
            </Switch.Group>
        </div>
    );
};
